<template>
  <div>
    <Head title="Nueva Categoría de Gasto" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/spents">Gastos</Link>
      <span class="text-indigo-400 font-medium">/</span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/spent-categories">Categorías</Link>
      <span class="text-indigo-400 font-medium">/</span> Crear
    </h1>

    <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="w-full"
            label="Nombre de la Categoría"
            placeholder="Ej: Mantenimiento de Ascensores, Pozos de Agua, etc."
            autofocus
          />
        </div>
        <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link
            class="text-sm font-medium text-gray-600 hover:text-gray-900"
            href="/spent-categories"
          >
            Cancelar
          </Link>
          <loading-button :loading="form.processing" class="btn-blue" type="submit">
            Guardar Categoría
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/spent-categories')
    },
  },
}
</script>
